import { createInstance } from '@/helpers/api/base'
import { ControlSheetRouteDTO } from '@/types/controlsheet'
import { useQuery } from '@tanstack/react-query'

const CONTROL_SHEET_ROUTE_POINTS_KEY = 'CONTROL_SHEET_ROUTE_POINTS'

export const useGetControlSheetRoutePoints = (date: string, routes: string[]) =>
    useQuery({
        queryKey: [CONTROL_SHEET_ROUTE_POINTS_KEY, date, [...routes].sort().join(',')],
        queryFn: () =>
            createInstance<ControlSheetRouteDTO[]>({
                url: '/control-sheets/routes/points',
                method: 'GET',
                params: {
                    Date: date,
                    Routes: routes,
                },
                paramsSerializer: {
                    indexes: null,
                },
            }),
        enabled: Boolean(date && routes.length > 0),
        staleTime: Infinity,
    })
